import { Product } from "features/ProductReel/types";
import React, { Fragment, useMemo } from "react";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText, shadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import ProductDescription from "./components/ProductDescription";
import ProductDescriptionText from "./components/ProductDescriptioText";
import Reviews from "./components/Reviews";
import TechnicalInfo from "./components/TechnicalInfo";
import { reviewsMock } from "./types";

interface ProductMoreInfoDesktopProps {
  fetchedProduct: Product;
}

const ProductMoreInfoDesktop: React.FC<ProductMoreInfoDesktopProps> = ({
  fetchedProduct,
}) => {
  const sectionsConfig = useMemo(() => {
    return [
      {
        title: fetchedProduct.tech_specs.title,
        showTitle: true,
        component: <TechnicalInfo data={fetchedProduct.tech_specs} />,
      },
      {
        title: "Описание",
        showTitle:
          fetchedProduct.description.text &&
          fetchedProduct.description.text !== "",
        component: (
          <ProductDescriptionText text={fetchedProduct.description.text} />
        ),
      },
      {
        title: "Екстри",
        showTitle: fetchedProduct.extras?.length > 0,
        component: <ProductDescription extras={fetchedProduct.extras} />,
      },
      // {
      //   title: "Отзиви",
      //   component: <Reviews reviews={reviewsMock} />,
      // },
    ];
  }, []);

  return (
    <ProductMoreInfoDesktopContainer>
      {sectionsConfig.map((item) => {
        return (
          item.showTitle && (
            <Section key={item.title}>
              <h3>{item.title}</h3>
              <Container>{item.component}</Container>
            </Section>
          )
        );
      })}
    </ProductMoreInfoDesktopContainer>
  );
};

const ProductMoreInfoDesktopContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px;
`;

const Section = styled.div`
  margin: 20px 0;
`;

const Container = styled.div`
  ${shadow}
`;

export default ProductMoreInfoDesktop;
